// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__SQ2nS","logout":"MainPage_logout__umj9I","links":"MainPage_links__uMVSf"};